







import { Component, Vue } from 'vue-property-decorator';
import GlobalLoader from '@/components/GlobalLoader.vue';
import API from '@/services/rest-api';

@Component({
  components: {
    GlobalLoader
  }
})
export default class App extends Vue {
  private refreshSessionInterval = 600000; // millisecond, 10 min

  mounted(): void {
    setInterval(() => {
      /* eslint-disable-next-line no-console */
      console.info('refreshSession...');
      API.refreshSession();
    }, this.refreshSessionInterval);
  }
}
